module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "model": _vm.queryForm
    }
  }, [(_vm.commercials.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "公司名称",
      "prop": "commercial_id"
    }
  }, [(_vm.commercials.length > 1) ? _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryForm.commercialId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "commercialId", $$v)
      },
      expression: "queryForm.commercialId"
    }
  }, _vm._l((_vm.commercials), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.commercials.length == 1) ? _c('el-input', {
    attrs: {
      "type": "text",
      "value": _vm.commercials[0].name,
      "disabled": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shops.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shopId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.remoteShopMethod,
      "placeholder": "请输入店铺"
    },
    model: {
      value: (_vm.queryForm.shopId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "shopId", $$v)
      },
      expression: "queryForm.shopId"
    }
  }, _vm._l((_vm.shopList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "交易时间:",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "size": "small",
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.queryForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "dateRange", $$v)
      },
      expression: "queryForm.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "交易类型:",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.type),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "type", $$v)
      },
      expression: "queryForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "全部"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "校园卡"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "非校园卡"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.printPDF
    }
  }, [_vm._v("打印")])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card mb20",
    staticStyle: {
      "background-color": "#eaf5fc"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('p', [_vm._v("销售订单总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.actualOrderCount) + "单")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('p', [_vm._v("商户结算款总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.sealAmount) + "元")])])], 1)], 1), _vm._v(" "), _c('export-excel', {
    staticClass: "fl",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "params": _vm.exportParams,
      "action": _vm.$apiUrl.checkBillTotalSchool,
      "target": 'oc',
      "field": _vm.field,
      "filename": _vm.filename,
      "fieldname": _vm.fieldName
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "时间",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "schoolName",
      "label": "学校名称",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commercialName",
      "label": "公司名称",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shopName",
      "label": "店铺名称",
      "width": "150",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "交易类型",
      "width": "150",
      "show-overflow-tooltip": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('span', [_vm._v("校园卡")]) : _vm._e(), _vm._v(" "), (scope.row.type == 2) ? _c('span', [_vm._v("非校园卡")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actualOrderNum",
      "label": "实际订单笔数（退款后）",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "incomeAmount",
      "label": "订单金额（退款后）",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceFee",
      "label": "外卖服务费",
      "width": "",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deliveryFee",
      "label": "配送费",
      "width": "",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commercialAmount",
      "width": "",
      "label": "商户结算款",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "alySubsidyTranslation",
      "width": "",
      "label": "平台优惠",
      "show-overflow-tooltip": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa92ed0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/finance/schoolTotalBill4.vue
// module id = 937
// module chunks = 0